/**
 * Short introduction shared with the sidebar manual presentation.
 * The full manual and section links come from usermanual.md via markdown.js.
 */

export const MANUAL_INTRO =
  "HEXATONE is a tool for exploring rational tuning (JI) by learning, playing, and composing. It includes a library of built-in microtonal tuning layouts and a scale workspace for live retuning, modulation, and rationalisation. Sounds may be captured as snapshots and edited in SEQUENCER for manual triggering or timed playback. The I/O tab provides settings for built-in sounds, MIDI controllers, and external synths. CALCULATOR provides useful information about the intonation of JI pitches.";
